import React from "react";

const Billing = ({ width, height, color, bgColor }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
        width={width ? width : "36px"}
      height={height ? height : "36px"}
      viewBox="0 0 512 512"
    >
    <g fill="none" stroke="#82AFC0" stroke-width="28" stroke-linecap="round" stroke-linejoin="round">
      <path d="M154 58H332L430 156V398C430 430 404 456 372 456H154C122 456 96 430 96 398V116C96 84 122 58 154 58Z"/>
      <path d="M332 60V146C332 152 337 157 343 157H428"/>
      <path d="M150 188H274"/>
      <path d="M150 255H314"/>
      <path d="M150 322H314"/>
      <path d="M365 174V278"/>
      <path d="M395 197C385 183 355 180 344 195C331 214 352 226 370 232C394 240 405 255 391 274C378 291 345 288 334 271"/>
    </g>
  </svg>

  );
};

export default Billing;
